var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showOverlay)?_c('div',{staticClass:"overlay_con"},[_c('div',{style:({
      height: '100%',
      background: _vm.datas.backColor,
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[(!_vm.imageList[0])?_c('div',{staticClass:"empty_con"},[_c('img',{attrs:{"src":require("@/assets/images/defaultPic2.png"),"alt":""}})]):_vm._e(),(_vm.imageList[0])?_c('div',{staticClass:"swiper-container"},[_c('div',{class:'swiper-wrapper type1'},_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide",on:{"click":function($event){return _vm.handleClickImg(item)}}},[_c('img',{attrs:{"src":item.imgUrl,"alt":"","draggable":"false"}})])}),0),_c('div',{staticClass:"swiper-pagination"})]):_vm._e()]),(_vm.datas.showSkipBtn || (!_vm.datas.showSkipBtn && _vm.timeOut))?_c('div',{staticClass:"skip_btn",style:({
      background: _vm.datas.skipBtnBgColor,
      color: _vm.datas.skipBtnColor,
    }),on:{"click":_vm.handleCloseOverlay}},[_vm._v(" "+_vm._s(_vm.timeOut ? "关闭" : "跳过 " + _vm.countdownTime)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }